<template>
  <div class="tab-container" :style="{ height: maxHeight - 100 + 'px' }">
    <customer-premises-toolbar :layer="layer" :editMode="editMode" />
    <customer-premises-table
      :layer="layer"
      :editMode="editMode"
      :originalObjects="originalObjects"
      :buildingUuid="buildingUuid"
      @updateTotalOfHPs="updateTotalOfHPs"
    />
  </div>
</template>

<script>
import CustomerPremisesToolbar from "./CustomerPremisesToolbar";
import CustomerPremisesTable from "./CustomerPremisesTable";
export default {
  name: "CustomerPremisesTab",
  components: { CustomerPremisesTable, CustomerPremisesToolbar },
  props: {
    layer: {
      type: String,
      required: true
    },
    editMode: Boolean,
    originalObjects: Array,
    buildingUuid: String,
    maxHeight: Number
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    updateTotalOfHPs(totalHPs) {
      this.$emit("updateTotalOfHPs", totalHPs);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/CustomerPremises/CustomerPremisesTab.vue